<div class="d-flex align-items-center justify-content-between">
    <span class="example-pizza-party">
        In Call With {{data.inCallWithContactName}}
    </span>&nbsp;
    <button mat-raised-button color="accent" (click)="viewCallDetail()"><i class="bi bi-caret-right"></i></button>
</div>